import React, {useState} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button
} from "@material-ui/core";
import {usePackageUpdateCautionStyles} from "../packagesCommonComponents/useStyles";
import {buyNewPackage} from "../../api/profileApi";
import CustomBackdropLoader from "../packagesCommonComponents/CustomBackdropLoader";
import PackageUpdateSuccess from "../packagesCommonComponents/PackageUpdateSuccess";
import ManageMethodModal from "../billingV2/subscription/ManageMethodModal";
import NewConfirmAlert from "../Common/NewConfirmAlert";

const PackageUpdateCaution = ({ isOpen, onClose, selectedPlan, onCloseUpdatePlanModal }) => {
    const classes = usePackageUpdateCautionStyles();
    const [isShowChangeCardModal, setShowChangeCardModal] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleBuy = async () => {
        try{
            setSubmitting(true);
            const response = await buyNewPackage({
                package_id: selectedPlan.plan_id,
                pricing_id: selectedPlan.price_id
            });

            if (response?.status === 'success'){
                onClose();
                onCloseUpdatePlanModal();
                PackageUpdateSuccess({
                    onCloseCallback: () => {

                    }
                });
            }else {
                window.showNotification('error', response.message || 'Something went wrong');
            }
        }catch (err){
            console.log(err);
        }finally {
            setSubmitting(false);
        }
    };

    const handleBuyPlan = async () => {
        NewConfirmAlert({
            title: 'Please confirm that you want to continue.',
            description: "By choosing to upgrade now, your trial will end immediately — even if the payment fails or the upgrade doesn’t go through.",
            cancelText: "Cancel",
            submitText: "Upgrade now",
            onSubmit: handleBuy,
            width: '480px'
        });
    };

    return (
        <Dialog open={isOpen} onClose={onClose} className={classes.dialog}>
            {
                submitting ?
                    <div style={{ width: '628px' }}>
                        <CustomBackdropLoader text={'Submitting request....'}/>
                    </div> :
                    <>
                        <DialogContent>
                            <div className={classes.iconWrapper}>
                                <img src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/choice_8586824.png`} alt={'choice'}/>
                            </div>
                            <DialogTitle className={classes.title}>
                                Upgrade to a Paid Plan
                            </DialogTitle>
                            <Typography variant="body1" className={classes.contentText}>
                                Please confirm that you would like to upgrade your free trial to a paid plan.
                                <br/>
                                If you'd like to update your card on file you can do so below.
                            </Typography>
                            <Typography variant="body2" className={classes.italicText}>
                                *When you click "Buy Now" your card on file will be charged.
                            </Typography>
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button
                                variant="contained"
                                className={classes.cancelButton}
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <div className={classes.actionButton}>
                                <Button
                                    variant="outlined"
                                    className={classes.updateCardButton}
                                    onClick={()=>{ setShowChangeCardModal(true); }}
                                >
                                    Update Card
                                </Button>
                                <Button
                                    variant="contained"
                                    className={classes.buyNowButton}
                                    onClick={handleBuyPlan}
                                >
                                    Buy Now
                                </Button>
                            </div>
                        </DialogActions>
                    </>
            }

            {
                isShowChangeCardModal &&
                <ManageMethodModal
                    open={isShowChangeCardModal}
                    onClose={()=>{ setShowChangeCardModal(false); }}
                />
            }
        </Dialog>
    );
}

export default PackageUpdateCaution;